import MilestoneCard from './MilestoneCard';

export default MilestoneCard;
